import React from 'react';
import { Input } from 'antd';
import { withRouter, RouteComponentProps } from 'react-router';
import Constants from '../../config/constants'
import Pagination from "react-js-pagination";
import toast from '../../components/toast'
import LoadingWheel from '../../components/loadingwheel'
import EllipsisProps from '../../components/textellipsis'
import sensorSore, { SensorData } from '../../store/sensorStore'
import sensorService from '../../services/sensorService';
import sensorStore from '../../store/sensorStore';
import RawDataModal from '../../components/rawdatamodal';
import authStore from '../../store/authStore';
import Select from '../../components/select';
import {Organization} from '../../interface'
import organizationService from '../../services/organizationService';
import "./SensorData.css"
import Utils from '../../helpers/Utility';
import moment from 'moment';

const { Search } = Input;
export interface SensorProps extends RouteComponentProps {}
export interface SensorState {
    sensorData      :   Array<SensorData>
    isLoading       :   Boolean,
    sensorFilter    :   string;
    organizationList:   Array<Organization>;
    organizationFilter? : any;
    sourceFilter    :   string;
    sourceTypeFilter:   string;
    pageNumber      :   number;
    showModal       :   boolean;
    modalData       :   string;
}

class SensorDataList extends React.Component<SensorProps, SensorState> {

    searchSensorRaw: any
    constructor(props : any){
        super(props);

        this.state = {
            sensorData      : [],
            sensorFilter    : '',
            organizationList: [],
            organizationFilter : {},
            sourceFilter    : 'internal',
            sourceTypeFilter: 'all',
            isLoading       : true,
            pageNumber      : 1,
            showModal       : false,
            modalData       : '',
        }

    this.searchSensorRaw = Utils.debounce(this.getSensorData, 700);
    }

    async componentDidMount(){
        // note : temp solution for the org admin access to all org
        if(authStore?.isSuperAdmin || (authStore?.isOrgAdmin() && authStore.currentUser.is_default)){
            await this.getOrganisations();
        }
        sensorStore.sensorData = [];
        await this.getSensorData(this.state.sensorFilter);
    }

    showModal = (data: string) =>{
        this.setState({modalData: data},()=>{
            Utils.showModal('rawData')
        })
    }

    getSensorData = async(sensorBoxName: string) => {

        try { 
            this.setState({isLoading: true, sensorFilter: sensorBoxName })
            let sensor_data;
            const orgId = this.state.organizationFilter?._id || undefined;
            if(this.state.sourceFilter === 'external'){
                const sourceType = this.state.sourceTypeFilter === 'all' ? 'all' : this.state.sourceTypeFilter || 'monnit';
                sensor_data = await sensorService.getExternalRawData(orgId, sourceType)
            } else {
                sensor_data = await sensorService.getInternalRawData(sensorBoxName, orgId)
            }
            sensorStore.sensorData = sensor_data;
            this.setState({
                sensorData: sensor_data.slice( 0, Constants.maxLimit),
                isLoading : false,
                pageNumber: 1
            })
        }catch(error: any){
            this.setState({isLoading : false})
            toast.error(error.response?.data?.message || error.response?.data?.detail || 'An error occurred')
        }
    }

    getOrganisations :any = async () => {
        try {
                const response = await organizationService.getOrganizations()
                this.setState({organizationList : response.data.organizations , organizationFilter : response.data.organizations[0]})
        } catch (error: any) {
                toast.error(error.response?.data?.message || 'An error occurred')
                this.setState({isLoading : false})
        }
    }

    handleFilterOrganization(option: any){
        this.setState({organizationFilter : option},()=>{
            if(this.state.sourceFilter === 'internal'){
                this.getSensorData(this.state.sensorFilter);
            } else {
                this.getSensorData('');
            }
        })
    }

    handleFilterSource(option: any){
        console.log("option: ==> ", option);
        this.setState({sourceFilter : option._id, sensorFilter: ''},()=>{
            this.getSensorData('');
        })
    }

    handleFilterSourceType(option: any){
        this.setState({sourceTypeFilter : option._id},()=>{
            this.getSensorData('');
        })
    }

    onPageChange = (pageNumber: number) => {
        const skip  = Constants.maxLimit * (pageNumber - 1);
        const limit = Constants.maxLimit * (pageNumber - 1) + Constants.maxLimit;
        this.setState({
            sensorData: sensorSore.sensorData.slice( skip, limit ),
            isLoading : false,
            pageNumber
        })
    }

    setSearchFilter(value: string) {

        this.setState({ sensorFilter: value }, () => {
            this.searchSensorRaw( value )
        })

    }

    render(){
        return (

            <div className="padding-b50">
              <div className="row mb-25">
                  <div className="col-xs-6 col-sm-6 col-md-6 col-lg-3 col-xl-4">
                        <p className="table-title media-padding">Raw Data</p>
                  </div>
                    <div className="col-xs-6 col-sm-6 col-md-6 col-lg-3 col-xl-2 media-margin-tp">
                    {// note : temp solution for the org admin access to all org
                    (authStore?.isSuperAdmin || (authStore?.isOrgAdmin() && authStore.currentUser.is_default)) &&
                            <div className="filter-select">
                                <label className="custom-label">Organization</label>
                                    <Select name = "typeFilter"
                                            data = {this.state.organizationList}
                                            value = {this.state.organizationFilter}
                                            onChange = {(e:any)=>this.handleFilterOrganization(e)}
                                    />
                            </div>
                            }
                    </div>
                    <div className="col-xs-6 col-sm-6 col-md-6 col-lg-3 col-xl-2 media-margin-tp">
                        <div className="filter-select">
                            <label className="custom-label">Source</label>
                            <Select name = "sourceFilter"
                                    data = {[{_id: 'internal', name: 'Internal'}, {_id: 'external', name: 'External'}]}
                                    value = {{_id: this.state.sourceFilter, name: this.state.sourceFilter === 'internal' ? 'Internal' : 'External'}}
                                    onChange = {(e:any)=>this.handleFilterSource(e)}
                            />
                        </div>
                    </div>
                    {this.state.sourceFilter === 'external' && 
                    <div className="col-xs-6 col-sm-6 col-md-6 col-lg-3 col-xl-2 media-margin-tp">
                        <div className="filter-select">
                            <label className="custom-label">Source Type</label>
                            <Select name = "sourceTypeFilter"
                                    data = {[{_id: 'all', name: 'All'}, {_id: 'monnit', name: 'Ext - MON'}, {_id: 'lgmv', name: 'Ext - LGMV'}, {_id: 'bas', name: 'Ext - BAS'}]}
                                    value = {{_id: this.state.sourceTypeFilter, name: this.state.sourceTypeFilter === 'all' ? 'All' : this.state.sourceTypeFilter === 'monnit' ? 'Ext - MON' : this.state.sourceTypeFilter === 'lgmv' ? 'Ext - LGMV' : 'Ext - BAS'}}
                                    onChange = {(e:any)=>this.handleFilterSourceType(e)}
                            />
                        </div>
                    </div>
                    }
                    {this.state.sourceFilter === 'internal' && 
                    <div className="col-xs-6 col-sm-6 col-md-6 col-lg-3 col-xl-2 media-margin-tp  mt-auto">
                        <Search
                            placeholder="Search"
                            value={this.state.sensorFilter}
                            size="large"
                            onChange={(e) => this.setSearchFilter(e.target.value)}
                            allowClear
                            enterButton />
                    </div>
                    }
               </div>
               {this.state.sensorData?.length !== 0 ?
                <div className="row no-gutters table-wrap">
                    <table className="table custom-table table-style">
                        <thead className="table-header-bg">
                            <tr>
                            <th scope="col">#</th>
                            <th scope="col">Sensor Box</th>
                            <th scope="col">Value</th>
                            <th scope="col">Created Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.sensorData ?
                                this.state.sensorData.map((item : SensorData,index) =>{
                                    const displayValue = typeof item.value === 'string' ? item.value : JSON.stringify(item.value);
                                    return(
                                        <tr className='click-icon' key={index} onClick={()=>this.showModal(displayValue)}>
                                        <th scope="row">{(Constants.maxLimit * (this.state.pageNumber - 1)) + index + 1}</th>
                                            <td><EllipsisProps length={16}>{item.sensor_name || ''}</EllipsisProps></td>
                                            <td><EllipsisProps length={50}>{displayValue}</EllipsisProps></td>
                                            <td>{moment(item.created_on).format('MM/DD/YYYY, HH:mm:ss')}</td>
                                        </tr>
                                    )

                                })
                                : null 
                            }
                        </tbody>
                        </table>
                </div>  
                : <>
                    {
                    sensorSore.sensorData?.length === 0 && !this.state.isLoading && (
                        <div className="text-center w-100 no-card-ph">
                            <div className="no-result-container">
                                <p className="no-cards"> No data found!</p>
                            </div>
                        </div> 
                       )
                    }
                    </>
                }        
               <div className="pagination-container">
               {Math.ceil(sensorSore.sensorData.length/Constants.maxLimit ) > 1?
   
                        <Pagination
                            hideNavigation
                            activePage={this.state.pageNumber}
                            itemsCountPerPage={Constants.maxLimit}
                            totalItemsCount={sensorSore.sensorData.length}
                            itemClass={"item-class"}
                            activeClass={"active-class"}
                            pageRangeDisplayed={5}
                            onChange={this.onPageChange}
                            />
                    
                    : null
                }
                </div> 
             {this.state.isLoading ? 
                <LoadingWheel/>
                :  null}
            <RawDataModal rawData={this.state.modalData}/>
          </div> 
        )
    }
}

export default withRouter(SensorDataList)

